import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "medium",
    title: "Смена статуса тайм-слота",
    "confirm-button-text": "Сохранить",
    "is-confirm": false,
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        placeholder: "Выберите статус",
        label: "title",
        searchable: false,
        disabled: _ctx.state.is_loading,
        loading: _ctx.data_state.statuses.is_loading,
        failed: _ctx.data_state.statuses.is_failed,
        options: _ctx.data_state.statuses.list,
        value: _ctx.state.statusId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.statusId) = $event)),
        "is-invalid": _ctx.state_form$.statusId.$error,
        "validation-errors": _ctx.state_form$.statusId.$errors,
        onRefresh: _ctx.loadStatuses
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}